import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminLoginPage = () => {
  const { user, login, authError, clearAuthError, isFirebaseConfigured } =
    useAuth();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState(null);

  useEffect(() => () => clearAuthError(), [clearAuthError]);

  if (user) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (!isFirebaseConfigured) {
    return (
      <section className="admin-login">
        <header>
          <h2>प्रशासनिक प्रवेश</h2>
          <span className="caption">Administrator Login</span>
        </header>
        <p>कृपया Firebase संयोजन विवरण जोड़ें।</p>
        <span className="caption">
          Provide Firebase credentials to enable the admin portal.
        </span>
      </section>
    );
  }

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setLocalError(null);
    try {
      await login(formState.email, formState.password);
      navigate("/admin/dashboard", { replace: true });
    } catch (error) {
      setLocalError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="admin-login">
      <header>
        <h2>प्रशासनिक प्रवेश</h2>
        <span className="caption">Administrator Login</span>
      </header>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">
          ईमेल
          <span className="caption">Email</span>
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          value={formState.email}
          onChange={handleChange}
        />
        <label htmlFor="password">
          कूटशब्द
          <span className="caption">Password</span>
        </label>
        <input
          id="password"
          name="password"
          type="password"
          required
          value={formState.password}
          onChange={handleChange}
        />
        {(localError || authError) && (
          <p className="form-error">{localError || authError.message}</p>
        )}
        <button type="submit" disabled={submitting}>
          प्रवेश करें
          <span className="caption">Sign In</span>
        </button>
      </form>
    </section>
  );
};

export default AdminLoginPage;
